import { TOOLS } from "./sdk.tools";
//import { jsbridge } from "./sdk.jsbridge.js";
import jsbridge from "@kkmh/jsbridge";

//BASE 基类
class BASE extends TOOLS{
    constructor(){
        super();
        this.ver = {
            name:"Quick look at SDK", 
            v:"v1.0.0",
            kuaikan: this.env === "dev" ? "https://www.quickcan.cn":"https://www.kuaikanmanhua.com",//官网域名
            h5: this.env === "dev" ? "https://h5.quickcan.cn":"https://h5.kuaikanmanhua.com",//h5 活动域名
            mh5: this.env === "dev" ? "https://m.quickcan.cn":"https://m.kuaikanmanhua.com"//m站域名
        };
        this.subscribeListenerOnViewBack();
        this.recivefreecardinfo();
        this.getLoginStatus();
        this.kkapp = this.isKKApp();
    }

    //调试输出
    debugLog(...ary){
        const href = window.location.href;
        if (/kuaikanmanhua.com/.test(href)) {
            return;
        }
        // eslint-disable-next-line no-console
        console.log(...ary);
    }

    /** 
       * * initCodeData 统一格式化返回的数据
       * 
       * @data 回调成功返回的数据
       * 
       * 返回 {code,data,message}
       * **/
    initCodeData(res){
        //res = this.packData(res);// 查看数据是否需要包装
        res = this.isObject(res) ? res :{};
        //判断:data 是否存在
        res = this.isObject(res) ? res :{};
        if(!this.isObject(res.data)){
            res ={
                code:200,
                data:res,
                message:"ok"
            }; 
        }

        //判断:code 是否存在
        if(!res.code){
            res.code = 200;
        }

        //判断:message 是否存在
        if(!res.message){
            res.message = "ok";
        }

        //统一使用message
        res.message = res.data.msg ? res.data.msg :(res.message ? res.message : "");
          
        return res;
    }

    /** 
       * * paramInit  hybrid协议 参数初始化 
       * 参数
       * options={
       *    @schema 'kkaction',//kkmhhybrid, kkhybrid, kkaction, kkmh，window
       *    @tagname 调用app方法名字 
       *    @is_del_nativecallback 是否删除客户端回调函数  默认不删除
       *    @debug  输出log(调试工具) 默认测试环境输出线上不输出
       *    @param  对象数据类型,其他配置项  根据app提供的方法传递参数
       *    @success 成功后的回调函数
       *    @error   失败后的回调
       * }
       * 
       * 返回:{
       *    schema, //协议类型
       *    tagname,//使用协议
       *    param,//传递的参数
       *    is_del_nativecallback,//是否删除客户端回调函数
       *    debug,// 是否打开调试
       *    success, //成功回调
       *    error //失败的回调
       * }
       * **/
    paramInit(options={}){
        const _this = this;
        //是否删除回调(app 调用的回调,默认不删除)
        let is_del_nativecallback = options.is_del_nativecallback;
        is_del_nativecallback = this.isBoolean(is_del_nativecallback)?is_del_nativecallback:false;
          
        //callback S
        let callback = options.callback || function(res){};
        let success = this.isFunction(options.success) ? options.success : callback;
        let error = options.error ? options.error :"";//失败后回调
        if( !this.isFunction(error) ){ error = () => {} }
        //callback E
          
          
        //schema S kkmhhybrid, kkhybrid, kkaction ...
        //tagname login_win 不能带有？等符号，会输出警告,在这格式化一次
        let schema = options.schema;
        schema = schema ? schema : "kkhybrid";
        let tagname = options.tagname;
        let param = options.param;
        //schema不是字符串置为空字符串
        schema = this.isString(schema)?schema:"";
        //tagname不是字符串置为空字符串
        tagname = this.isString(tagname)?tagname:"";
        //param 处理
        param = this.isObject(param) ? param : {};
        if(schema=="kkaction"){
            // tagname
            let paramData = this.extendUrlValue({url:tagname});
            let strAry = tagname.split("?"); 
            tagname = strAry[0] ? strAry[0] : "";
              
            //param
            if(JSON.stringify(paramData)!="{}"){
                if(JSON.stringify(param)!="{}"){
                    param = {
                        ...param,
                        ...paramData
                    };
                }else{
                    param = paramData;
                }
            }
        }
        //schema E
        let debug = options.debug;
        let href = window.location.href;
        if(debug === undefined){
            debug = /kuaikanmanhua.com|kkmh.com/.test(href)?false:true;
        }else{
            if(!this.isBoolean(debug)){
                debug = /kuaikanmanhua.com|kkmh.com/.test(href)?false:true;
            }
        }
          
        return {
            schema, //协议类型
            tagname,//使用协议
            param,//传递的参数
            is_del_nativecallback,//是否删除客户端回调函数
            debug,// 是否打开调试
            success, //成功回调
            error //失败的回调
            // callback:(res, nativecallback_name) => {
            //     res = kkmh.isJson(res) ? JSON.parse(res) : res;
            //     callback(res,nativecallback_name);
            // }
        };
    }


    /**
       * * 内置hybrid跳转(方法)封装
       * @options 同paramInit
       * 
       * 返回:无
       * **/ 
    hybrid(options={}) {
        let { 
            schema, //协议类型
            tagname,//使用协议
            param,//传递的参数
            is_del_nativecallback,//是否删除客户端回调函数
            debug,// 是否打开调试
            success, //成功回调
            error //失败的回调
        } = this.paramInit(options);//接收 初始化参数
            // console.log(schema, //协议类型
            //       tagname,//使用协议
            //       param,//传递的参数
            //       is_del_nativecallback,//是否删除客户端回调函数
            //       debug);
        const _this = this;
        let kkHybrid = {
            schema, //协议类型
            tagname,//使用协议
            param,//传递的参数
            is_del_nativecallback,//是否删除客户端回调函数
            debug,// 是否打开调试
            callback(res, nativecallback_name){
                res = _this.isJson(res) ? JSON.parse(res) : res;
                res = _this.initCodeData(res);
                if( res.code == 200 ){
                    success(res,nativecallback_name);
                }else{
                    error(res,nativecallback_name);
                }
            }
        };
            // ******* 谷歌浏览器模拟端内执行 *******
        if(/kuaikan\//.test(navigator.userAgent.toLowerCase()) && /kuaikan-simulation$/.test(navigator.userAgent.toLowerCase()) && window.webkit){ 
            window.webkit.messageHandlers.kkHybridBridge.postMessage(kkHybrid);
        }

        if( !this.isKKApp() ){ //不是客户端的情况下
            this.debugLog("当前运行环境不是快看app",`schema:${schema} tagname:${tagname}`, "param:",param);
            error({code:400,message:"Running environment is not KK App.",data:{}});
        }else {
            jsbridge(kkHybrid);
        }
    }

    // 初始化 app 默认调用js函数
    subscribeListenerOnViewBack(callback) {
        let listen = "subscribeListenerOnViewBack";
        window[listen] = null;
        const _this = this;
        window[listen] = function(res) {
            if (typeof res == "string") res = JSON.parse(res);
            if( _this.isFunction(callback) ) {
                callback(res);
            } 
        };
    }

    recivefreecardinfo(callback){
        let listen = "recivefreecardinfo";
        window[listen] = null;
        const _this = this;
        window[listen] = function(res) {
            if (typeof res == "string") res = JSON.parse(res);
            if( _this.isFunction(callback) ) {
                callback(res);
            } 
        };
    }

    getLoginStatus(callback){
        let listen = "getLoginStatus";
        window[listen] = null;
        const _this = this;
        window[listen] = function(res) {
            if (typeof res == "string") res = JSON.parse(res);
            if( _this.isFunction(callback) ) {
                callback(res);
            } 
        };
    }
    
}

let base = new BASE();

export{
    base, //内置hybrid跳转(方法)封装 
    BASE //基类 
};




// WEBPACK FOOTER //
// ./src/assets/js/SDK_copy/libs/sdk.base.js